// Initial count of items in a filter
export const viewableCount = 4;
